/** @format */

import axios from "../lib/axios";

import {
	ORDER_CREATE_FAIL,
	ORDER_CREATE_REQUEST,
	ORDER_CREATE_SUCCESS,
	ORDER_DETAILS_FAIL,
	ORDER_DETAILS_REQUEST,
	ORDER_DETAILS_SUCCESS,
	ORDER_PAY_FAIL,
	ORDER_PAY_REQUEST,
	ORDER_PAY_SUCCESS,
	ORDER_RATES_FAIL,
	ORDER_RATES_REQUEST,
	ORDER_RATES_SUCCESS,
} from "../constants/orderConstants";
import { tokenRedirectCheck } from "../utils/tokenRedirectCheck";

export const createPaymentIntent = async (options) => {
	const res = await axios.post("orders/createPaymentIntent", options);
	return res.data;
};

export const createOrder = (order) => async (dispatch, getState) => {
	try {
		if (!order.isSubmitted) {
			dispatch({
				type: ORDER_CREATE_REQUEST,
			});
		}
		const {
			userLogin: { userInfo },
			userLogin,
		} = getState();

		console.log("Email is " + order.email + "");
		// get isGuest from userLogin
		const isGuest = userLogin.isGuest;

		let config;
		if (isGuest) {
			config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer Guest`,
				},
			};
		} else {
			config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${userInfo.token}`,
				},
			};
		}

		const { data } = await axios.post("orders", order, config);
		console.log("Data is " + JSON.stringify(data));
		// dispatch(tokenRedirectCheck(data, history)); //checks if token is valid
		if (!order.isSubmitted) {
			dispatch({
				type: ORDER_CREATE_SUCCESS,
				payload: data,
			});
		}
	} catch (error) {
		console.log("Error is " + error);
		dispatch({
			type: ORDER_CREATE_FAIL,
			payload:
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
		});
	}
};

export const createSwatchOrder =
	(order, swatchShippingAddress) => async (dispatch, getState) => {
		try {
			dispatch({
				type: ORDER_CREATE_REQUEST,
			});

			const { data } = await axios.post(
				"orders/swatch",
				order,
				swatchShippingAddress
			);

			dispatch({
				type: ORDER_CREATE_SUCCESS,
				payload: data,
			});

			return data.insertId;
		} catch (error) {
			dispatch({
				type: ORDER_CREATE_FAIL,
				payload:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			});
		}
	};

//Order Details
export const getOrderDetails =
	(userInfo, history) => async (dispatch, getState) => {
		try {
			dispatch({
				type: ORDER_DETAILS_REQUEST,
			});

			const {
				userLogin: { userInfo },
				userLogin,
			} = getState();

			// get isGuest from userLogin
			const isGuest = userLogin?.isGuest || false;

			let config;
			if (isGuest) {
				config = {
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer Guest`,
					},
				};
			} else {
				config = {
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${userInfo.token}`,
					},
				};
			}

			const { data } = await axios.post("orders/myorders", userInfo, config);
			dispatch(tokenRedirectCheck(data, history)); //checks if token is valid

			dispatch({
				type: ORDER_DETAILS_SUCCESS,
				payload: data,
			});
		} catch (error) {
			dispatch({
				type: ORDER_DETAILS_FAIL,
				payload:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			});
		}
	};

//Pay Order actions
export const payOrder =
	(order, paymentResult, history) => async (dispatch, getState) => {
		try {
			dispatch({
				type: ORDER_PAY_REQUEST,
			});
			const {
				userLogin: { userInfo },
			} = getState();

			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${userInfo.token}`,
				},
				//Token for private user
			};
			//Change the API
			const { data } = await axios.put("orders", order, config);
			dispatch(tokenRedirectCheck(data, history)); //checks if token is valid

			dispatch({
				type: ORDER_PAY_SUCCESS,
				payload: data,
			});
		} catch (error) {
			dispatch({
				type: ORDER_PAY_FAIL,
				payload:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			});
		}
	};

//Pay Order actions

export const getRates =
	(shipment_details, history) => async (dispatch, getState) => {
		try {
			dispatch({
				type: ORDER_RATES_REQUEST,
			});

			//Change the API
			const { data } = await axios.post("orders/rates", shipment_details);

			if (data.message === "error getting rates") {
				console.log("Dead");
				history("/shipping");
			}

			//const [ground, select, overnight] = data.rates;

			const ground = { total_charge: { amount: data.rates } };
			const overnight = { total_charge: { amount: 9999999 } };
			const select = { total_charge: { amount: 9999999 } };

			dispatch({
				type: ORDER_RATES_SUCCESS,
				payload: { ground, select, overnight },
			});

			return { ground, select, overnight };
		} catch (error) {
			dispatch({
				type: ORDER_RATES_FAIL,
				payload:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			});
		}
	};
